///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../../../baseClasses/dataMaintenance.interface.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../common/collection-api.ts"/>


module Meevo.Components.Controls.SmartMover {
    import IReportDrawer = Meevo.Plugins.Reports.IReportDrawer;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

    export class ReportDrawersCollection extends SmartMoverApiCollection<IReportDrawer> implements IApiCollection<IReportDrawer> {

        protected get url() {
            return 'report/Drawer';
        }

        constructor(connectedModel: ModelValueType[], items: IReportDrawer[] = [], options: ICollectionOptions<IReportDrawer> = {}) {
            super(connectedModel, items, options);

            this.updateCriteria({
                objectStateEnumList: [ObjectStateEnum.Active, ObjectStateEnum.Inactive]
            });
        }
    }

}